module.exports = __webpack_public_path__ + "static/media/food.74c3cd7f.svg";